import { Option, createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const publishCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('publish')
    .description(t('site_publish_command_def.description'))
    .addOption(
      new Option(
        '--source <local|remote>',
        t('site_publish_command_def.option.source')
      ).choices(['local', 'remote'] as const)
    )
    .option(
      '-y, --approve-preview',
      t('site_publish_command_def.option.approve_preview')
    )
    .option('-f, --force', t('site_publish_command_def.option.force'))
    .action(async (options, command) => {
      const { runCommand } = await import('./run-command.js');
      const { publish } = await import('../publish/index.js');

      await runCommand(command, services, cliVersion, (model) =>
        publish(model, services, options)
      );
    });
};
